module.exports = __webpack_public_path__ + "img/cp33.081cae42.png";